import Collapse from './Collapse';
export { CollapseProps, PanelProps } from './Collapse';
export { CollapsePanelProps } from './CollapsePanel';
export default Collapse;
